export default __webpack_public_path__ + "media/images/react_icons/slider_filters_white-0a481624f5ae748a5e5af8c34ecc042c.svg";